/**
 * Indian FY: 1 April – 31 March. Returns labels like "2026-2027".
 */
export function indianFinancialYearLabel(date = new Date()) {
  const y = date.getFullYear();
  const month = date.getMonth() + 1; // 1–12
  const startYear = month >= 4 ? y : y - 1;
  const endYear = startYear + 1;
  return `${startYear}-${endYear}`;
}

/** The three choices for the dropdown (current FY only — no duplicate bare GST/GTIN/U2MC). */
export function departmentOptionsWithFy(yearLabel = indianFinancialYearLabel()) {
  return ['GST', 'GTIN', 'U2MC'].map((b) => `${b} ${yearLabel}`);
}

/**
 * Older DB/UI values were bare "GST". Map those to current FY wording so only year-suffixed options exist.
 */
export function coerceLegacyDepartmentToFy(value, date = new Date()) {
  const s = String(value || '').trim();
  if (!s) return '';
  const fy = indianFinancialYearLabel(date);
  const bare = ['GST', 'GTIN', 'U2MC'];
  if (bare.includes(s)) return `${s} ${fy}`;
  return s;
}

/**
 * Dropdown list: exactly the three current-FY rows. Appends saved value only if it is a different FY (still valid, not redundant).
 */
export function departmentSelectOptions(savedValue = '') {
  const main = departmentOptionsWithFy(indianFinancialYearLabel());
  const v = String(savedValue || '').trim();
  if (v && !main.includes(v)) {
    return [...main, v];
  }
  return main;
}
